export default {
  // aplies margin bottom to the component
  CMS_MODULE: 'cms-module',
  SPACING_BOTTOM: 'spacing-bottom',
  // Some components break the general rule, and have less than 80px separation with component above.
  SMALL_SPACING_TOP: 'small-spacing-top'
}
